import Login from '../../pages/login'

export default {
  path: 'login',
  component: Login,
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js